import { User } from "../models/user.model";
import { responseHero } from "../utils/axiosInterceptor";

export const fetchClusterUsers = (): Promise<User[]> => {
    return new Promise<User[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/cluster/users`).then((response) => {
            resolve(response.data as User[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};